import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarker = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 20,
	viewBox: "0 0 14 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7 0C3.13 0 0 3.13 0 7C0 11.17 4.42 16.92 6.24 19.11C6.64 19.59 7.37 19.59 7.77 19.11C9.58 16.92 14 11.17 14 7C14 3.13 10.87 0 7 0ZM7 9.5C6.33696 9.5 5.70107 9.23661 5.23223 8.76777C4.76339 8.29893 4.5 7.66304 4.5 7C4.5 6.33696 4.76339 5.70107 5.23223 5.23223C5.70107 4.76339 6.33696 4.5 7 4.5C7.66304 4.5 8.29893 4.76339 8.76777 5.23223C9.23661 5.70107 9.5 6.33696 9.5 7C9.5 7.66304 9.23661 8.29893 8.76777 8.76777C8.29893 9.23661 7.66304 9.5 7 9.5Z",
		fill: "#1A1D1E"
	})]
});
const ForwardRef = forwardRef(SvgMarker);
export { ForwardRef as ReactComponent };
